/* eslint-disable react/no-array-index-key */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';

type Props = {
  // If href is undefined, logos will be wrapped in a div element.
  href?: string;
  ariaLabel?: string;
  className?: string;
  // Maximum of 3 logos.
  logos: Array<React.ReactNode>;
};

const styles = {
  logosContainer: css`
    display: flex;
    align-items: center;
  `,
  logoSpacer: css`
    margin-left: 16px;
    margin-right: 16px;
    height: 26px;
    border-left: 1px solid var(--cds-color-grey-300);
  `,
};

const HomeLogoGridItemModuleWrapper = ({
  href,
  ariaLabel,
  className,
  children,
}: {
  href?: string;
  ariaLabel?: string;
  className?: string;
  children: React.ReactNode;
}) => {
  if (href) {
    return (
      <TrackedLink2
        className={className}
        href={href}
        aria-label={ariaLabel}
        trackingName="logo"
        data-testid="home-logo"
      >
        {children}
      </TrackedLink2>
    );
  } else {
    return <div className={className}>{children}</div>;
  }
};

const HomeLogoGridItemModule = ({ href, ariaLabel = 'Coursera', className, logos }: Props) => {
  return (
    <HomeLogoGridItemModuleWrapper href={href} ariaLabel={ariaLabel} className={className}>
      <div css={styles.logosContainer}>
        {logos.slice(0, 3).map((logo, index) => {
          if (index > 0) {
            return (
              <React.Fragment key={index}>
                <div css={styles.logoSpacer} />
                <div>{logo}</div>
              </React.Fragment>
            );
          } else {
            return <div key={index}>{logo}</div>;
          }
        })}
      </div>
    </HomeLogoGridItemModuleWrapper>
  );
};

export default HomeLogoGridItemModule;
